import { Modal } from "@/Common/Components/Modals/Modal";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";

interface INewVitalSignWithoutSpecialityWarningPopupProps {
    onClose: () => void;
}

export function NewVitalSignWithoutSpecialityWarningPopup(props: INewVitalSignWithoutSpecialityWarningPopupProps): JSX.Element {
    const { getText } = useTranslation();

    return (
        <Modal
            title={getText("AddVitalSignsLabel")}
            onClose={props.onClose}
            draggable
            showOverlay
            showX
            centerContent
            footer={(
                <div className="text-right">
                    <button className="btn btn-primary" onClick={props.onClose}>{getText("OKLabel")}</button>
                </div>
            )}
        >
            <div>
                <span>{getText("VitalSignNoSpecialityErrorLabel")}</span>
            </div>
        </Modal>
    );
}
